import { adEditorStyle } from '@bingads-webui-campaign-react/ad-editor-styles';

export const campaignCreationAdEditorOverrideStyle = (_, { palette = {} }) => ({
  '& .audience-campaign-creation-wizard-container div[data-current-step-name^="audience-campaign-creation-wizard-step3"]': {
    '& .created-ad-list-container.row .ad-list-item .create-another-ad': {
      lineHeight: 'unset',
      color: '#00a2ff',
      fontSize: 14,
      border: 'none',
      backgroundColor: 'unset',
      padding: 2,
      position: 'relative',
      top: '38px',

      '&:hover, &:active': {
        color: `${palette.themeDarker} !important`,
        textDecoration: 'underline',
      },
      '&:focus': {
        border: 'none',
        outline: `1px solid ${palette.neutralSecondary}`,
      },
    },
    '& .created-ad-list-container.row .existing-ad .existing-ad-options': {
      ...adEditorStyle({ palette })['& .created-ad-list-container.row .existing-ad .existing-ad-options'],
      display: 'inline',
    },
    '& .created-ad-list-container.row .existing-ad .existing-ad-options button': {
      ...adEditorStyle({ palette })['& .created-ad-list-container.row .existing-ad .existing-ad-options button'],
      opacity: '0',
      '&:hover, &:active': {
        color: `${palette.themeDarker} !important`,
        textDecoration: 'underline',
      },
    },
    '& .created-ad-list-container.row .existing-ad:hover .existing-ad-options button': {
      opacity: '1',
    },
    '& .created-ad-list-container.row .existing-ad .existing-ad-options button:focus': {
      opacity: '1',
      border: 'none',
      outline: `1px solid ${palette.neutralSecondary}`,
    },
  },
  '& .alert-info-inline': {
    '& > a': {
      textDecoration: 'none !important',
    },
    '& > a:active': {
      textDecoration: 'none !important',
    },
    '& > a:hover': {
      textDecoration: 'none !important',
    },
  },
  '& a.helpbutton': {
    '&:active': {
      textDecoration: 'none !important',
    },
    '&:hover': {
      textDecoration: 'none !important',
    },
  },
});
